import React from 'react';

function OverflowMenu({ children }) {
  if (!children.length) {
    return null;
  }

  return (
    <div className={'overflow-menu'}>
      <span><span className="ic-menu" /></span>
      <ul>
        {children}
      </ul>
    </div>
  );
}

export default OverflowMenu;